import { Box, Typography } from "@mui/material";
import { SummaryContent, SummaryItem, SummaryWrapper } from "./styles";
import pxToRem from "theme/base/pxToRem";

interface IProps {
  timeKeepingData: [
    {
      reasonCode?: string;
      reasonName?: string;
      totalDays?: number;
    },
  ];
}

export const SummaryTimeSheet = ({ timeKeepingData }: IProps) => {
  return (
    <SummaryWrapper>
      {(timeKeepingData ?? []).map((item, index) => (
        <SummaryItem key={index}>
          <SummaryContent className="summary-content">
            <Box
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              flexDirection={"row"}
              gap={1}
            >
              <Box
                width={pxToRem(4)}
                height={pxToRem(4)}
                borderRadius={pxToRem(100)}
                sx={(theme) => ({
                  background: theme.palette.background.bgBrand,
                })}
              />
              <Typography
                sx={(theme) => ({
                  fontSize: 14,
                  color: theme.palette.text.textPrimary,
                })}
              >
                {`${item?.reasonName ?? ""} (${item?.reasonCode ?? ""})`}
              </Typography>
            </Box>
            <Typography
              sx={(theme) => ({
                fontSize: 14,
                color: theme.palette.text.textPrimary,
              })}
            >
              {item.totalDays}
            </Typography>
          </SummaryContent>
        </SummaryItem>
      ))}
    </SummaryWrapper>
  );
};
